/**
 * Pure HTTP request functions for traversal API calls.
 * Each function returns the raw AxiosResponse so the calling store
 * can handle state updates via MobX actions.
 */
import { AxiosInstance, AxiosResponse } from 'axios'
import { Data, RootObject } from 'interfaces/ApolloResponse.interface'
import { Patch } from 'interfaces/ApolloResponse.interface'
import { TraversalResponse } from './types'

export const postCreateTraversal = (
  client: AxiosInstance,
  advertisementId: string,
  data: Data
): Promise<AxiosResponse<TraversalResponse>> =>
  client.post<TraversalResponse>(`/traversal/${advertisementId}`, data)

export const getTraversal = (
  client: AxiosInstance,
  advertisementId: string,
  traversalId: string
): Promise<AxiosResponse<RootObject>> =>
  client.get(`/traversal/${advertisementId}/${traversalId}`)

export const patchTraversal = (
  client: AxiosInstance,
  advertisementId: string,
  traversalId: string,
  patches: Patch[]
): Promise<AxiosResponse<RootObject>> =>
  client.patch(`/traversal/${advertisementId}/${traversalId}`, patches)

export const putTraversal = (
  client: AxiosInstance,
  advertisementId: string,
  traversalId: string,
  data: Data
): Promise<AxiosResponse<RootObject>> =>
  client.put(`/traversal/${advertisementId}/${traversalId}`, data)

export const postResumeTraversal = (
  client: AxiosInstance,
  resumeHash: string
): Promise<AxiosResponse> => client.post(`/resume/${resumeHash}`)

export const postFinalizeTraversal = (
  client: AxiosInstance,
  advertisementId: string,
  traversalId: string,
  data: Data
): Promise<AxiosResponse<{ result: { uri: Location } }>> =>
  client.post(`/finalize/${advertisementId}/${traversalId}`, data)

export const postCheckTenantEmail = (
  client: AxiosInstance,
  email: string
): Promise<AxiosResponse> => client.post(`/cso`, { email })
